/**
 * External login destinations. Authentication lives on the member/creator
 * platforms, not on this marketing site — keep both URLs in one place.
 */
export const MEMBER_LOGIN_URL = "https://portal.fivestar.video/sign-in";
export const CREATOR_LOGIN_URL = "https://creator.fivestar.video/sign-in";

/** Native app store listings (one app, both personas). App Store id matches eas.json ascAppId. */
export const APP_STORE_URL = "https://apps.apple.com/us/app/fivestar-app/id6788433867";
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.fivestar.creator&hl=en_US";

/** QR code for https://fivestar.video/app (tagged utm_source=website,
 *  utm_medium=qr, utm_campaign=app_launch so the pageview beacon counts
 *  scans). /app sends phones to their store listing (src/pages/GetTheApp.tsx).
 *  Generated with the `qrcode` package; shared by the header overlay and /app. */
export const GET_THE_APP_QR_SRC = "/images/app-promo/get-the-app-qr.svg";
